import React from 'react';
import { LayoutDashboardIcon, TicketIcon, UsersIcon, BarChart3Icon, SettingsIcon } from 'lucide-react';
interface SidebarProps {
  activePage: string;
  onNavigate: (page: string) => void;
}
export function Sidebar({
  activePage,
  onNavigate
}: SidebarProps) {
  const navItems = [{
    name: 'Dashboard',
    icon: LayoutDashboardIcon
  }, {
    name: 'Tickets',
    icon: TicketIcon
  }, {
    name: 'Team',
    icon: UsersIcon
  }, {
    name: 'Analytics',
    icon: BarChart3Icon
  }];
  return <aside className="z-10 flex h-full min-h-screen w-64 flex-col border-r border-[#003f75] bg-[#0d4f8b] text-white shadow-lg" data-id="element-17" data-mp="3q9upjtn31myt">
      <div className="border-b border-white/15 bg-white px-5 py-6" data-id="element-18" data-mp="3ge1fqi0r07kq">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/b8f45dd7-12b2-4e29-ad43-1640d9093f8e.jpg" alt="MortgagePros" className="h-auto w-36" data-id="element-19" data-mp="3gbootfd0imvj" />
        <p className="mt-3 text-[11px] font-bold uppercase tracking-[0.16em] text-[#0d4f8b]" data-id="element-20" data-mp="37f676za8ele9">
          Service Operations
        </p>
      </div>

      <nav aria-label="Primary navigation" className="flex-1 space-y-1 px-4 py-6" data-id="element-21" data-mp="1qqnfwaq7q74v">
        {navItems.map(item => <button key={item.name} onClick={() => onNavigate(item.name)} className={`flex w-full items-center space-x-3 rounded-lg border-l-4 px-4 py-3 transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#0d4f8b] ${activePage === item.name ? 'border-white bg-white text-[#0d4f8b] shadow-sm' : 'border-transparent text-white/85 hover:bg-white/10 hover:text-white'}`} data-id="element-22" data-mp="1d0a7665hyoeh">
            <item.icon className="w-5 h-5" data-id="element-23" data-mp="20o1vk84barw4" />
            <span className="font-medium" data-id="element-24" data-mp="20n0b5d1eot1q">{item.name}</span>
          </button>)}
      </nav>

      <div className="border-t border-white/15 p-4" data-id="element-25" data-mp="k90b822k93eh">
        <button className="mb-2 flex w-full items-center space-x-3 rounded-lg px-4 py-3 text-white/85 transition-colors hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#0d4f8b]" data-id="element-26" data-mp="p9xt0djnrvfg">
          <SettingsIcon className="h-5 w-5" data-id="element-27" data-mp="2m1kaq6d7ooot" />
          <span className="font-medium" data-id="element-28" data-mp="2h893i44hm5wd">Settings</span>
        </button>
        <div className="mt-2 flex items-center space-x-3 px-4 py-3" data-id="element-29" data-mp="2d75kx9v21vrg">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-lg font-bold text-[#0d4f8b]" data-id="element-30" data-mp="2d6x6ven74keo">
            AU
          </div>
          <div className="flex flex-col text-left" data-id="element-31" data-mp="238gau39ehflr">
            <span className="text-sm font-medium text-white" data-id="element-32" data-mp="23b2jy7bxw363">Admin User</span>
            <span className="text-xs text-white/65" data-id="element-33" data-mp="1yaeuhq3czudz">Mortgage Operations</span>
          </div>
        </div>
      </div>
    </aside>;
}